import { render, staticRenderFns } from "./UiPopoverItem.vue?vue&type=template&id=10098444&scoped=true&"
import script from "./UiPopoverItem.vue?vue&type=script&lang=js&"
export * from "./UiPopoverItem.vue?vue&type=script&lang=js&"
import style0 from "./UiPopoverItem.vue?vue&type=style&index=0&id=10098444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10098444",
  null
  
)

export default component.exports